// extracted by mini-css-extract-plugin
export default {"wrapper":"PersonPage_wrapper__03m2h","person_name":"PersonPage_person_name__uN2+c","container":"PersonPage_container__Si-XY"};